import { computed, getCurrentInstance, inject, ref, unref } from 'vue';
import { isNumber } from 'lodash-es';

const INITIAL = {
  current: 0,
};

const zIndex = ref(0);

export const DEFAULT_INITIAL_ZINDEX = 2000;

export const ZINDEX_INJECTION_KEY = Symbol('kkZIndexContextKey');

export const ZINDEX_CONTEXT_KEY = Symbol('zIndexContextKey');

export const useZIndex = (zIndexOverrides) => {
  const increasingInjection = getCurrentInstance()
    ? inject(ZINDEX_INJECTION_KEY, INITIAL)
    : INITIAL;

  const zIndexInjection =
    zIndexOverrides ||
    (getCurrentInstance() ? inject(ZINDEX_CONTEXT_KEY, undefined) : undefined);

  const initialZIndex = computed(() => {
    const zIndexFromInjection = unref(zIndexInjection);
    return isNumber(zIndexFromInjection)
      ? zIndexFromInjection
      : DEFAULT_INITIAL_ZINDEX;
  });

  const currentZIndex = computed(() => initialZIndex.value + zIndex.value);

  const nextZIndex = () => {
    increasingInjection.current++;
    zIndex.value = increasingInjection.current;
    return currentZIndex.value;
  };

  return {
    initialZIndex,
    currentZIndex,
    nextZIndex,
  };
};
